export default __webpack_public_path__ + "static/media/Category=Koncert.37b45499.png";